/**
 * @module store/tax/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Success loading tax settings
   *
   * @since Version 1.0.2
   */
  [types.GET_TAX_KINDCHALLENGE_ASYNC.PENDING](state) {
    state.isTaxSettingsLoading = true;
  },


  /**
   * Mutation: Error during tax settings loading
   *
   * @since Version 1.0.2
   */
  [types.GET_TAX_KINDCHALLENGE_ASYNC.FAILURE](state) {
    state.isTaxSettingsLoading = false;
  },


  /**
   * Mutation: Successful loaded tax settings
   *
   * @since Version 1.0.2
   */
  [types.GET_TAX_KINDCHALLENGE_ASYNC.SUCCESS](state, { data }) {
    state.taxSettings = { ...data };
    state.isTaxSettingsLoading = false;
  },
};
/* eslint-enable no-param-reassign */
